var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Búsqueda individual"}},[_c('div',[_c('ComboBusquedaIndividualVue')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }